import { productConstants } from "../actions/types";
const initialState = {
    productid: undefined,
    product: undefined
};
export const productsReducer = (state = initialState, action) => {
    switch (action.type) {
        case productConstants.SET_PRODUCT:
            return Object.assign(Object.assign({}, state), { product: action.payload });
        case productConstants.SET_PRODUCT_ID:
            return Object.assign(Object.assign({}, state), { productid: action.payload });
        default:
            return state;
    }
};
